import { apiFetchJson, apiFetchVoid } from '../http/apiFetch';

export interface UpdateMerchantBody {
  email?: string;
  merchantEmail?: string;
  phone?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  firstName?: string;
  lastName?: string;
  banned?: boolean;
  company?: string;
}

export interface InviteMerchantBody {
  email: string;
  suggestedMerchantName: string;
  companyId: string;
}

export async function updateMerchant(
  id: string,
  body: UpdateMerchantBody,
  getAccessToken: () => Promise<string | undefined>
): Promise<void> {
  await apiFetchVoid(`/api/admins/merchants/${encodeURIComponent(id)}`, {
    method: 'PUT',
    getAccessToken,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
}

export async function deleteMerchant(
  id: string,
  getAccessToken: () => Promise<string | undefined>
): Promise<void> {
  await apiFetchVoid(`/api/admins/merchants/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    getAccessToken,
  });
}

export async function inviteMerchant(
  body: InviteMerchantBody,
  getAccessToken: () => Promise<string | undefined>
): Promise<void> {
  await apiFetchJson<unknown>('/api/companies/merchant-invitations/single', {
    method: 'POST',
    getAccessToken,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
}
